import checkService from "../../services/checkService";
import leadService from "../../services/leadService";
import geoService from "../../services/geoService";

const getDefaultState = () => {
  return {
    products: null,
    ranges: null,
    wantGreen: false,
    wantOnlineGreen: false,
    onlineGreenProduct: null,
    onlineGrayProduct: null
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setProducts(state, value) { state.products = value },
    setRanges(state, value) { state.ranges = value },
    selectProducts(state, payload) {
      let index = state.ranges.findIndex(x => x.range === payload.range.range);
      if(payload.electricity)
        state.ranges[index].electricity = payload.electricity;

      if(payload.gas)
        state.ranges[index].gas = payload.gas;
    },
    setWantGreen(state, value) {
      state.wantGreen = value
    },
    setWantOnlineGreen(state, value) {
      state.wantOnlineGreen = value
    },
    setOnlineGreenProduct(state, value) {
      state.onlineGreenProduct = value
    },
    setOnlineGrayProduct(state, value) {
      state.onlineGrayProduct = value;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    async getSimulation(context) {
      if(!context.state.forced) {
        let simulationData = await context.dispatch("getSimulationData");

        try {
          let response = await checkService.getSimulation(simulationData);
          context.dispatch("setRanges", response);
        } catch (error) {
          throw error;
        }
      }
    },

    sendMail(context) {
      let data = {
        uuid: context.rootState.common.uuid,
        lang: context.rootState.common.lang
      };

      leadService.getMail(data);
    },

    async generatePdf(context) {
      let data = {
        uuid: context.rootState.common.uuid,
        lang: context.rootState.common.lang,
        customerType: context.rootState.contact.isPro ? 'pro' : 'resi',
        view: 'simulation'
      };

      try {
        context.commit("common/setPrintLoading", true, {root: true})
        await leadService.getPdf(data);
        context.commit("common/setPrintLoading", false, {root: true})
      } catch (error) {
        context.commit("common/setPrintLoading", false, {root: true})
        throw error;
      }
    },

    async setRanges(context, result) {
      let hasElec = context.rootGetters["energy/hasElec"];
      let hasGas = context.rootGetters["energy/hasGas"];


      // Put all products in one array
      let products = [];

      let productsElWithBaseOnline = null;
      let onlineGreenProduct = null;
      let onlineGrayProduct = false;

      if(hasElec)
      {
        productsElWithBaseOnline = [...result.electricity];

        onlineGreenProduct = productsElWithBaseOnline.filter(product => product.productId === 900432);

        products.push(...productsElWithBaseOnline)
      }

      if(hasGas) products.push(...result.gas);

      // Get all distinct ranges
      let ranges = [...new Set(products.map(x => x.range))];
      ranges = ranges.map(x => {
        return { range: x, name: x, electricity: null, gas: null, products: [] };
      })

      products.forEach(product => {
        product.duration = product.duration > 10 ? product.duration / 12 : product.duration;

        let range = ranges.find(x => x.range === product.range);

        // Default product
        let actual = range[product.energyType];
        if(!actual || product.total === undefined || (!actual.advised && (product.total.priceEuro < actual.total.priceEuro || product.advised))) {
          range[product.energyType] = product
        }

        range.products.push(product);
      });

      context.commit("setProducts", products);
      context.commit("setRanges", ranges);
      context.commit("setOnlineGreenProduct", ...onlineGreenProduct);
      context.commit("setOnlineGrayProduct", ...onlineGrayProduct);

    },
    async changeRangesType(context, type) {
      let ranges = context.state.ranges;

      context.state.products.forEach(product => {
        let range = ranges.find(x => x.range === product.range);

        if(product.contractType === type) {
          range[product.energyType] = product
        }
      });

      context.commit("setRanges", ranges);
    },
    async changeProducts(context, payload) {

      let ranges = context.state.ranges;

      let products = context.state.products.filter(product => product.energyType === payload.energy)

      products.forEach(product => {
        let range = ranges.find(x => x.range === product.range);

        if(product.duration === payload.duration && product.contractType === payload.type) {
          range[product.energyType] = product
        }
      });

      context.commit("setRanges", ranges);
    },
    getSimulationData(context) {
      let consumptionsArray = context.rootState.consumption.consumptions.filter(
        consumption =>
          context.rootState.consumption.meterType.includes(
            consumption.meterType
          ) && consumption.meterType !== "gas"
      );

      let consumptions = consumptionsArray.reduce((acc, it) => {
        if (!(it.meterType.includes("injection"))) {
          if (it.meterType !== "mono") {
            acc[it.meterType] = it.value;
          } else {
            acc["day"] = it.value;
          }
        }
        return acc;
      }, {});

      let injections = consumptionsArray.reduce((acc, it) => {
        if (it.meterType.includes("injection")) {
          if (it.meterType !== "injectionBase") {
            acc[it.meterType] = it.value;
          } else {
            acc["injectionDay"] = it.value;
          }
        }
        return acc;
      }, {});

      let simulationData = {
        customerType: context.rootState.contact.isPro ? "pro" : "resi",
        eco: true,
        promo: true,
        postalCode: context.rootState.calculation.zipCode,
        town: context.rootState.calculation.city,
        area: context.rootState.calculation.area,
        instalment: true
      };

      // if(router.currentRoute.query["promo"]) simulationData['promo'] = router.currentRoute.query["promo"];

      if (context.rootGetters["energy/hasElec"]) {
        simulationData.electricity = {
          powerPv: context.rootState.consumption.hasSolarPanels
            ? context.rootState.consumption.solarPanelsPower
            : null,
          consumption: consumptions,
          injection: injections,
          products: context.rootState.podium.simulationProducts.electricity,
          scenarioPv: context.rootState.consumption.hasSolarPanels
            ? context.rootState.consumption.solarPanelsScenario
            : null
        };

        if (geoService.getRegion(simulationData.postalCode) === "BE-VLG") {
          simulationData.hasSmartMeter = context.rootState.consumption.hasSmartMeter;

          if (simulationData.hasSmartMeter) {
            simulationData.hasQuarterRegime = context.rootState.consumption.hasQuarterRegime;
            simulationData.peakLevel = context.rootState.consumption.peakLevel;
          }
        }
      }

      if (context.rootGetters["energy/hasGas"]) {
        let consumptionGas = context.rootState.consumption.consumptions.find(
          consumption => consumption.meterType === "gas"
        ).value;

        simulationData.gas = {
          consumption: consumptionGas,
          products: context.rootState.podium.simulationProducts.gas
        };
      }

      return simulationData;
    },

    async save(context) {
      let data = {
        uuid: context.rootState.common.uuid
      };

      try {
        let ranges = context.state.ranges;

        ranges.forEach(range => {
          range['wantGreen'] = context.state.wantGreen;
          range['wantOnlineGreen'] = context.state.wantOnlineGreen;
        })

        data["simulationResult"] = ranges;
        data["simulation"] = 1

        await leadService.save(data);
      } catch (error) {
        throw error;
      }
    }
  },
  getters: {
    selectedProducts: () => range => {
      let products = [];

      if (range.electricity)
        products.push(range.electricity);

      if (range.gas)
        products.push(range.gas);

      return products;
    },
    sameOptions: (state, getters) => rangeName => {
      let sameOptions = true;
      let range = state.ranges.find(range => range.range === rangeName);

      let products = getters.selectedProducts(range);

      if(products.length > 1)
        sameOptions = products[0].id === products[1].peer;

      return sameOptions;
    },
    availableTypes: state => product => {
      let products = state.products.filter(x => {

        return (
          x.range === product.range &&
          x.energyType === product.energyType &&
          x.contractType !== product.contractType
        )
      });

      return products;
    },
    availableDurations: state => product => {
      let products = state.products.filter(x => {
        return (
          x.range === product.range &&
          x.energyType === product.energyType &&
          x.duration !== product.duration &&
          x.contractType === product.contractType
        )
      });

      return products;
    },
    getById: state => (id, duration) => {
      return state.products.find(product => {
        return product.productId.toString() === id.toString() && (product.duration === duration || duration === 0)
      });
    },
    hasRange: state => (range) => {
      return state.ranges.map(item => item.name).includes(range)
    },
    hasDiscount: state => {
      return state.ranges && state.ranges.some(range => (range.electricity && range.electricity.subtotal.discount) || (range.gas && range.gas.subtotal.discount))
    },
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/simulation.js